<style scoped="scoped" lang="scss">
/deep/ .info {
  display: flex;
  margin-left: 70px;

  //align-items: center;
  .info_item {
    flex: 1;
    margin-left: 5px;
    max-width: 33.33%;
  }
}

._form /deep/ .el-input {
  min-width: 98px;
  height: 28px !important;
  width: 98px !important;
}

._form /deep/ .el-input-number {
  min-width: 98px;
  height: 28px !important;
  width: 98px !important;
}

._form /deep/ .el-input__inner {
  height: 28px !important;
}

._form /deep/ .el-input__icon {
  line-height: 28px !important;
}
</style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/out/order/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('chukudanhao')">
            <el-input v-model="yt.conditions.no"></el-input>
          </el-form-item>
          <el-form-item :label="$t('kehumingcheng')">
            <!--            <yi_cross_select multiple :component="'web_wms_delivery_issue_customer_information'"-->
            <!--                :ids.sync="yt.conditions.wmsCustomerIds">-->
            <!--            </yi_cross_select>-->
            <el-select collapse-tags v-model="yt.conditions.wmsCustomerIds" multiple filterable>
              <el-option v-for="(item, index) in customerList" :key="index" :label="item.customerCodeName" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('shenhezhuangtai')">
            <el-select v-model="yt.conditions.checkStatus">
              <el-option :label="$t('daishenhe')" :value="0"></el-option>
              <el-option :label="$t('yishenhe')" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('danjuzhuangtai')">
            <el-select v-model="yt.conditions.status">
              <el-option :label="$t('weichuku')" :value="0"></el-option>
              <el-option :label="$t('bufenchuku')" :value="1"></el-option>
              <el-option :label="$t('quanbuchuku')" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('danjuriqi')">
            <yi_time_input :format="'yyyy-MM-dd'" type="date" :time.sync="yt.conditions.billDate"> </yi_time_input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain" :loading="yt.loading">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ orderBy: 'createTime desc', type: 2 })" :loading="yt.loading">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button
          size="mini"
          @click="
            yt.showEditDialog('xinzeng', null, 'w2', beforeShowEditDialog);
            setDefaultValue();
            getCustomerList();
          "
          type="primary"
          v-if="utils.checkPower('web_wms_out_order_product_add_button')"
        >
          {{ $t('xinzeng') }}
        </el-button>
      </template>
      <!-- 自定义某个字段 -->
      <!--单据类型-->
      <template #danjuleixing="scope">
        <span v-if="scope.row.type === 1">{{ $t('wudanchuku') }}</span>
        <span v-if="scope.row.type === 2">{{ $t('chengpinchuku') }}</span>
      </template>
      <!--审核状态-->
      <template #shenhezhuangtai="scope">
        <span v-if="scope.row.checkStatus === 0">{{ $t('daishenhe') }}</span>
        <span v-if="scope.row.checkStatus === 1">{{ $t('yishenhe') }}</span>
      </template>
      <!--单据状态-->
      <template #danjuzhuangtai="scope">
        <span v-if="scope.row.status === 0">{{ $t('weichuku') }}</span>
        <span v-if="scope.row.status === 1">{{ $t('bufenchuku') }}</span>
        <span v-if="scope.row.status === 2">{{ $t('quanbuchuku') }}</span>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1" v-if="scope.row.checkStatus === 0">
            <el-popconfirm :title="$t('quedingshenheshuju?')" @confirm="examine(scope.row)">
              <el-button type="text" slot="reference" v-if="utils.checkPower('web_wms_out_order_product_check_button')">{{ $t('shenhe') }}</el-button>
            </el-popconfirm>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.checkStatus === 0">
            <el-button type="text" @click="showUpdateDialog(scope.row)" v-if="utils.checkPower('web_wms_out_order_product_edit_button')">
              {{ $t('bianji') }}
            </el-button>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.checkStatus === 1">
            <el-button type="text" @click="yt.showEditDialog('chakan', scope.row, '80%')" v-if="utils.checkPower('web_wms_out_order_product_view_button')">
              {{ $t('chakan') }}
            </el-button>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.checkStatus === 1 && scope.row.status === 2">
            <el-popover placement="top" width="200" trigger="click">
              <el-button @click="printDefault(scope.row)" type="text">
                {{ $t('morenmoban') }}
              </el-button>
              <el-button @click="yt.showEditDialog('dayin', scope.row, '80%')" type="text">
                {{ $t('qitamoban') }}
              </el-button>
              <el-button slot="reference" type="text">
                {{ $t('dayin') }}
              </el-button>
            </el-popover>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.checkStatus === 0">
            <el-button type="text" class="font-color-danger" @click="yt.remove(scope.row, '/web/out/order/delete')" :loading="yt.editObj.loading" v-if="utils.checkPower('web_wms_out_order_product_delete_button')">
              {{ $t('shanchu') }}
            </el-button>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.checkStatus === 1 && scope.row.status === 0">
            <el-popconfirm :title="$t('quedingbohuishuju?')" @confirm="reject(scope.row)">
              <el-button type="text" slot="reference" v-if="utils.checkPower('web_wms_out_order_product_back_button')">{{ $t('shenhebohui') }}</el-button>
            </el-popconfirm>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.status === 2 || scope.row.status === 1">
            <el-button class="font-color-danger" type="text" v-if="utils.checkPower('web_wms_out_order_product_quash')" @click="quash(scope.row)">
              {{ $t('chexiao') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <div style="margin-top: 8px;margin-left: 56px;margin-bottom: 16px;color: #303133;font-weight: bold;font-size: 16px">
          {{ $t('chukudantouxinxi') }}
        </div>
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth" style="margin-left: 100px">
            <el-form-item class="noborder" :label="$t('danjuleixing')" required>
              <el-select disabled v-model="yt.editObj.type">
                <el-option :label="$t('chengpinchuku')" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('kehumingcheng')">
              <!--              <yi_cross_select :max="1" :component="'web_wms_delivery_issue_customer_information'"-->
              <!--                  :ids.sync="yt.editObj.wmsCustomerId">-->
              <!--              </yi_cross_select>-->
              <el-select v-model="yt.editObj.wmsCustomerId" clearable filterable>
                <el-option v-for="(item, index) in customerList" :key="index" :label="item.customerCodeName" :value="item.id"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('danjuriqi')" required>
              <yi_time_input :is_current="true" :format="'yyyy-MM-dd'" type="date" :time.sync="yt.editObj.billDate"> </yi_time_input>
            </el-form-item>
            <el-form-item :label="$t('beizhu')">
              <el-input v-model="yt.editObj.remark"></el-input>
            </el-form-item>
          </el-form>
          <div style="margin-top: 8px;margin-left: 56px;margin-bottom: 16px;color: #303133;font-weight: bold;font-size: 16px">
            {{ $t('chukudanmingxixinxi') }}
          </div>
          <div class="info">
            <div class="info_item"><span style="color: #F56C6C">*</span>{{ $t('wuliaobianma/mingcheng') }}</div>
            <!--            <div class="info_item">{{$t('wuliaopicihao')}}</div>-->
            <div class="info_item">{{ $t('chanpinpicihao') }}</div>
            <div class="info_item">{{ $t('shengchangongdanhao') }}</div>
            <div class="info_item"><span style="color: #F56C6C">*</span>{{ $t('danwei') }}</div>
            <div class="info_item"><span style="color: #F56C6C">*</span>{{ $t('chukushuliang') }}</div>
            <div class="info_item">{{ $t('beizhu') }}</div>
          </div>
          <div class="_form" style="margin-left: -25px;margin-top: 8px">
            <div class="info" v-for="(item, index) in yt.editObj.outOrderDetailList">
              <div>
                <el-button type="text" icon="el-icon-remove-outline" @click="deleteItem(index)"> </el-button>
              </div>
              <yi_cross_select :key="item.tmpId" style="margin-left: 8px;" :max="1" :selectTitle="'code,name'" :component="'web_base_matter_list'" :ids.sync="item.materialId" :objs="item.materials" @getItems="changeMaterial(index, $event)"> </yi_cross_select>
              <el-input style="margin-left: 20px;" type="text" size="mini" v-model="item.materialBatchNo"> </el-input>
              <el-input style="margin-left: 20px;" type="text" size="mini" v-model="item.woNo"> </el-input>
              <yi_dictionary_select style="margin-left: 20px;" :type="'UNIT_CONVERSION_TYPE'" :ids.sync="item.unit"> </yi_dictionary_select>
              <el-input-number style="margin-left: 20px;" :precision="5" :step="0" :min="0" :controls="false" v-model="item.quantity" size="mini"> </el-input-number>
              <el-input style="margin-left: 20px;" type="text" size="mini" v-model="item.remark"> </el-input>
            </div>
            <div style="margin-left: 70px;">
              <el-button style="font-size: 14px" type="text" icon="el-icon-circle-plus-outline" @click="addItem">
                {{ $t('zengjiayitiaochukuxinxi') }}
              </el-button>
              <el-button style="font-size: 14px" type="primary" size="mini" @click="isShowUploadDialog = true">
                {{ $t('daoru') }}
              </el-button>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/out/order/insertOrderAndDetail', beforAdd)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <div style="margin-top: 8px;margin-left: 56px;margin-bottom: 16px;color: #303133;font-weight: bold;font-size: 16px">
          {{ $t('chukudantouxinxi') }}
        </div>
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth" style="margin-left: 100px">
            <el-form-item class="noborder" :label="$t('danjuleixing')" required>
              <el-select disabled v-model="yt.editObj.type" @change="$forceUpdate()">
                <el-option :label="$t('chengpinchuku')" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('kehumingcheng')">
              <!--              <yi_cross_select :max="1" :component="'web_wms_delivery_issue_customer_information'"-->
              <!--                  :ids.sync="yt.editObj.wmsCustomerId">-->
              <!--              </yi_cross_select>-->
              <el-select v-model="yt.editObj.wmsCustomerId" clearable filterable>
                <el-option v-for="(item, index) in customerList" :key="index" :label="item.customerCodeName" :value="item.id"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('danjuriqi')" required>
              <yi_time_input :format="'yyyy-MM-dd'" type="date" :time.sync="yt.editObj.billDate"> </yi_time_input>
            </el-form-item>
            <el-form-item :label="$t('beizhu')">
              <el-input v-model="yt.editObj.remark"></el-input>
            </el-form-item>
          </el-form>
          <div style="margin-top: 8px;margin-left: 56px;margin-bottom: 16px;color: #303133;font-weight: bold;font-size: 16px">
            {{ $t('chukudanmingxixinxi') }}
          </div>
          <div class="info">
            <div class="info_item"><span style="color: #F56C6C">*</span>{{ $t('wuliaobianma/mingcheng') }}</div>
            <div class="info_item">{{ $t('chanpinpicihao') }}</div>
            <div class="info_item">{{ $t('shengchangongdanhao') }}</div>
            <div class="info_item"><span style="color: #F56C6C">*</span>{{ $t('danwei') }}</div>
            <div class="info_item"><span style="color: #F56C6C">*</span>{{ $t('chukushuliang') }}</div>
            <div class="info_item">{{ $t('beizhu') }}</div>
          </div>
          <div v-loading="true" v-if="yt.editObj.isMaterialLoading == true" style="height: 80px;width:100%;"></div>
          <div class="_form" style="margin-left: -25px;margin-top: 8px" v-if="yt.editObj.showFlag">
            <div class="info" v-for="(item, index) in yt.editObj.outOrderDetailList">
              <div>
                <el-button type="text" icon="el-icon-remove-outline" @click="deleteItem(index)"> </el-button>
              </div>
              <yi_cross_select :key="item.tmpId" style="margin-left: 8px;" :max="1" :selectTitle="'code,name'" :component="'web_base_matter_list'" :ids.sync="item.materialId" :objs="item.materials" @getItems="changeMaterialUpdate(index, $event)"> </yi_cross_select>
              <el-input style="margin-left: 20px;" type="text" size="mini" v-model="item.materialBatchNo"> </el-input>
              <el-input style="margin-left: 20px;" type="text" size="mini" v-model="item.woNo"> </el-input>
              <yi_dictionary_select style="margin-left: 25px;" :type="'UNIT_CONVERSION_TYPE'" :ids.sync="item.unit"> </yi_dictionary_select>
              <el-input-number style="margin-left: 25px;" :precision="5" :step="0" :min="0" :controls="false" v-model="item.quantity" size="mini"> </el-input-number>
              <el-input style="margin-left: 20px;" type="text" size="mini" v-model="item.remark"> </el-input>
            </div>
            <div style="margin-left: 70px;">
              <el-button style="font-size: 14px" type="text" icon="el-icon-circle-plus-outline" @click="addItem">
                {{ $t('zengjiayitiaochukuxinxi') }}
              </el-button>

              <el-button style="font-size: 14px" type="primary" size="mini" @click="isShowUploadDialog = true">
                {{ $t('daoru') }}
              </el-button>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/out/order/insertOrderAndDetail')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 查看-->
      <template v-if="yt.editObj.action == 'chakan'">
        <div class="dialog-scroller">
          <check_list :check="yt.editObj"></check_list>
        </div>
      </template>
      <!-- 打印 -->
      <template v-if="yt.editObj.action == 'dayin'">
        <div class="dialog-scroller">
          <yi_cross_select :isShowButtons="false" :isShowCaoZuo="false" :isInput="false" :component="'web_base_print_list'" :type="'5'" :status="1" :max="1" :ids.sync="printId" @getItems="getPrint"> </yi_cross_select>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yulan()" type="primary">
            {{ $t('yulan') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog :show-close="true" :visible.sync="isShowPrintDialog" :width="'960px'" :close-on-click-modal="false" append-to-body="append-to-body">
      <div class="dialog-scroller">
        <template_product_out id="wmsPrintId" v-if="isShowPrintDialog" :config="currentPrint.config" :order="yt.editObj"> </template_product_out>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="isShowPrintDialog = false">{{ $t('quxiao') }}</el-button>
        <el-button size="mini" @click="dayin()" type="primary">
          {{ $t('dayin') }}
        </el-button>
      </span>
    </el-dialog>

    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="isShowUploadDialog" width="80%" :close-on-click-modal="false" append-to-body="append-to-body">
      <div class="dialog-scroller">
        <importExcel v-if="isShowUploadDialog" ref="importExcel" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="default" size="mini" @click="isShowUploadDialog = false">{{ $t('quxiao') }}</el-button>
        <el-button type="primary" size="mini" @click="save()" :loading="yt.editObj.loading">{{ $t('baocun') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import html2canvas from 'html2canvas';
import print from 'print-js';
import template_product_out from '@@/pages/web/base/print/template_product_out';
import check_list from '@@/pages/web/wms/out_order_product/check/list';
import importExcel from '@@/pages/web/wms/out_order_product/import_excel.vue';
export default {
  name: 'web_wms_out_order_product_list',
  components: {
    check_list,
    importExcel,
    template_product_out
  },
  data() {
    return {
      moRenMubanLoading: false,
      qiTaMubanLoading: false,
      printId: null,
      currentPrint: null,
      isShowPrintDialog: false,
      customerList: [],
      columns: [
        {
          label: 'chukudanhao',
          prop: 'no',
          width: 150
        },
        {
          label: 'kehumingcheng',
          prop: 'wmsCustomer.name',
          width: 150
        },
        {
          label: 'danjuleixing',
          type: 'slot',
          prop: 'type',
          width: 150
        },
        {
          label: 'shenhezhuangtai',
          prop: 'checkStatus',
          type: 'slot'
        },
        {
          label: 'danjuzhuangtai',
          prop: 'status',
          type: 'slot'
        },
        {
          label: 'danjuriqi',
          prop: 'billDate',
          type: 'time',
          format: 'YYYY-MM-DD',
          width: 100
        },
        {
          label: 'beizhu',
          prop: 'remark',
          width: 150
        },
        {
          label: 'chuangjianren',
          prop: 'createByObject.nickname',
          width: 150
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time',
          width: 150
        },
        {
          label: 'shenheren',
          prop: 'checkUserObject.nickname',
          width: 150
        },
        {
          label: 'shenheshijian',
          prop: 'checkTime',
          type: 'time',
          width: 150
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 200,
          fixed: 'right'
        }
      ],
      isShowUploadDialog: false
    };
  },
  watch: {
    'yt.isShowEditDialog': {
      handler(n, o) {
        if (n == false && this.yt.editObj.action === 'chakan') {
          this.yt.get();
        }
      },
      immediate: false,
      deep: true
    }
  },
  created() {
    setTimeout(() => {
      this.getCustomerList();
      this.yt.conditions = {
        //表格默认按照创建时间降序排序。
        orderBy: 'createTime desc',
        type: 2
      };
      this.yt.get(1);
    }, 300);
  },
  methods: {
    showUpdateDialog(row) {
      const ids = row.outOrderDetailList.map(item => item.materialId);

      this.http
        .get('/web/basic/material/getMaterialByIds', {
          params: {
            ids: ids
          }
        })
        .then(res => {
          let materials = res.data;
          row.outOrderDetailList.forEach(item => {
            const material = materials.find(m => m.id === item.materialId);
            this.$set(item, 'materials', [material]);
          });
          this.$set(row, 'isMaterialLoading', true);
          this.yt.showEditDialog('bianji', row, 'w2');
          setTimeout(() => {
            this.$set(this.yt.editObj, 'showFlag', true);
            this.$set(this.yt.editObj, 'isMaterialLoading', false);
          }, 300);
        });

      this.getCustomerList();
    },
    // 获取客户编码、名称
    async getCustomerList() {
      return await this.http
        .get(
          '/web/wms/customer/page?' +
            this.qs.stringify({
              pageNum: 1,
              pageSize: 999
              // orderBy: 'sort',
            })
        )
        .then(response => {
          this.customerList = response.data.rows || [];
          for (let i = 0; i < this.customerList.length; i++) {
            const customerCodeName = this.customerList[i]['code'] + '/' + this.customerList[i]['name'];
            this.$set(this.customerList[i], 'customerCodeName', customerCodeName);
          }
          console.log('this.customerList', this.customerList);
        });
    },
    /**
     * 物料选中后回调
     * @param index 当前行
     * @param item 选中后的项目
     */
    changeMaterial(index, item) {
      this.$set(this.yt.editObj.outOrderDetailList[index], 'unit', item.defaultUnit || '');
    },
    changeMaterialUpdate(index, item) {
      this.$set(this.yt.editObj.outOrderDetailList[index], 'unit', item.defaultUnit || '');
    },
    beforAdd(params) {
      params.wmsCustomerId = parseInt(params.wmsCustomerId);
      return params;
    },
    //审核审核
    examine(editObj) {
      this.http
        .post('/web/out/order/check', {
          id: editObj.id
        })
        .then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.yt.get(1);
        })
        .catch(msg => {
          this.utils.errorMessage(msg);
        });
    },
    //驳回
    reject(editObj) {
      this.http
        .post('/web/out/order/reject', {
          id: editObj.id
        })
        .then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.yt.get(1);
        })
        .catch(msg => {
          this.utils.errorMessage(msg);
        });
    },
    setDefaultValue() {
      this.yt.editObj.type = 2;
    },
    //增加一条出库信息
    addItem() {
      // console.log('this.yt.editObj.outOrderDetailList', this.yt.editObj.outOrderDetailList)
      this.yt.editObj.outOrderDetailList.push({
        tmpId: new Date().getTime(),
        materialId: '',
        unit: '',
        quantity: undefined,
        remark: '',
        materialBatchNo: '',
        woNo: ''
      });
    },
    //减少一条出库信息
    deleteItem(key) {
      this.yt.editObj.outOrderDetailList = this.yt.editObj.outOrderDetailList.filter((item, index) => {
        return index !== key;
      });
    },
    beforeShowEditDialog(editObj) {
      console.log('editObj', editObj);
      if (editObj.action === 'xinzeng') {
        editObj.outOrderDetailList = [
          {
            materialId: '',
            unit: '',
            quantity: undefined,
            remark: ''
          }
        ];
      }
      return editObj;
    },
    yulan() {
      if (!this.currentPrint) {
        return this.$message.warning(this.$t('qingxuanzemoban'));
      }
      this.http
        .get('/web/out/order/detail/page?pageNum=1&pageSize=1000', {
          params: {
            outOrderId: this.yt.editObj.id
          }
        })
        .then(res => {
          console.log(res);
          this.yt.editObj.details = res.data.rows;
          this.isShowPrintDialog = true;
        })
        .catch(msg => {
          this.utils.errorMessage(msg);
        });
    },
    dayin() {
      html2canvas(document.getElementById('wmsPrintId'), { scale: 8 }).then(async canvas => {
        const imgData = canvas.toDataURL('image/png');
        print({
          printable: imgData,
          type: 'image',
          documentTitle: '',
          modalMessage: this.$t('zhengzaijiazaiwenjian,qingshaohou')
          // footer: "My Footer Text"
        });

        // 新增打印记录
        const outOrderNo = this.yt.editObj.no;
        let data = {
          outOrderNo: outOrderNo,
          businessType: '6',
          templateId: this.currentPrint.id
        };
        const res = await this.http.post('/web/print/record/createPrintRecord', data);
        if (res.code === 200) {
          this.yt.isShowEditDialog = false;
          this.isShowPrintDialog = false;
        }
      });
    },

    getPrint(item) {
      this.currentPrint = item;
      console.log(item);
    },

    printDefault(row) {
      this.yt.editObj = this.utils.copy(row);
      this.moRenMubanLoading = true;
      this.http
        .get('/web/printConfig/page?pageNum=1&pageSize=1000', {
          params: {
            type: 5,
            isDefault: 1
          }
        })
        .then(res => {
          this.moRenMubanLoading = false;
          console.log(res);
          if (res.data.rows.length == 0) {
            this.utils.errorMessage(this.$t('meiyoudayinmoban'));
            return;
          }
          this.currentPrint = res.data.rows[0];
          this.yulan();
        })
        .catch(msg => {
          this.moRenMubanLoading = false;
          this.utils.errorMessage(msg);
        });
    },

    save() {
      let importData = this.$refs.importExcel.convertData;
      this.isShowUploadDialog = false;
      if (importData && importData.length > 0) {
        if (this.yt.editObj.action === 'xinzeng') {
          this.yt.editObj.outOrderDetailList = [];
          this.$nextTick(() => {
            importData.forEach(item => {
              item.materialId = Number(item.materialId);
            });
            //拿到id数组，然后去获取objs
            const ids = importData.map(item => item.materialId);
            this.http
              .get('/web/basic/material/getMaterialByIds', {
                params: {
                  ids: ids
                }
              })
              .then(res => {
                console.log(res);
                //把res.data.rows赋值给importData的material字段
                importData.forEach(item => {
                  const material = res.data.find(m => m.id === item.materialId);
                  console.log(material);
                  item.materials = [material];
                });

                this.yt.editObj.outOrderDetailList = importData;
              });
          });
        } else if (this.yt.editObj.action === 'bianji') {
          this.$nextTick(() => {
            importData.forEach(item => {
              item.materialId = Number(item.materialId);
            });

            //拿到id数组，然后去获取objs
            const ids = importData.map(item => item.materialId);
            this.http
              .get('/web/basic/material/getMaterialByIds', {
                params: {
                  ids: ids
                }
              })
              .then(res => {
                console.log(res);
                //把res.data.rows赋值给importData的material字段
                importData.forEach(item => {
                  const material = res.data.find(m => m.id === item.materialId);
                  console.log(material);
                  item.materials = [material];
                  this.yt.editObj.outOrderDetailList.push(item);
                });
              });
          });
        }
      }
    },
    quash(row) {
      // 使用Vue.js的$confirm方法创建确认框
      this.$confirm(this.$t('shifouchexiaodangqianjilu'), this.$t('tishi'), {
        confirmButtonText: this.$t('chexiao'),
        cancelButtonText: this.$t('quxiao'),
        type: 'warning'
      })
        .then(() => {
          const param = row;
          // 如果用户点击了确认按钮，则执行撤销操作
          this.http
            .post('/web/out/order/quash', param)
            .then(res => {
              this.utils.successMessage(this.$t('caozuochenggong'));
              this.yt.get(1);
            })
            .catch(err => {
              this.utils.errorMessage(err);
              this.stopRepairLoading = false;
            });
        })
        .catch(() => {
          // 如果用户点击了取消按钮，则不执行任何操作
          alert('已取消撤销操作！');
        });
    }
  }
};
</script>
